module.exports = __webpack_public_path__ + "img/social_media_gg.6d7257d9.svg";